export default function carousel() {

// Smooth Scroll
    jQuery('a[href*="#"]').not('[href="#"]').not('[href="#0"]').not('[href="#carouselActivity"]').click(function (event) {
        if (
            location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') &&
            location.hostname == this.hostname
        ) {
            var target = jQuery(this.hash);
            target = target.length ? target : jQuery('[name=' + this.hash.slice(1) + ']');

            if (target.length) {
                event.preventDefault();
                jQuery('html, body').animate({
                    scrollTop: target.offset().top - 50
                }, 1000, function () {
                    var $target = jQuery(target);
                    $target.focus();
                    if ($target.is(":focus")) {
                        return false;
                    } else {
                        $target.attr('tabindex', '-1');
                        $target.focus();
                    }

                });
            }
        }
    });


    (function () {
        return jQuery(".carousel.lazy").on("slide.bs.carousel", function (ev) {
            var lazy = jQuery(ev.relatedTarget).find("img[data-src]");

            lazy.attr("src", lazy.data('src'));
            lazy.removeAttr("data-src");
        });
    });
}
